module.exports = __webpack_public_path__ + "media/3_26.3319ad27.wav";